var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2c5.414 0 9.84 4.307 9.996 9.72L22 12c0 5.414-4.307 9.84-9.72 9.996L12 22c-5.42 0-9.84-4.304-9.996-9.72L2 12c0-5.42 4.304-9.84 9.72-9.996zm0 2-.237.003C7.443 4.128 4 7.663 4 11.986l.003.25C4.128 16.559 7.663 20 11.986 20l.25-.003C16.554 19.872 20 16.33 20 12.014l-.003-.25A8 8 0 0 0 12 4zm-.001 11 .117.006a1.254 1.254 0 0 1 1.133 1.244 1.26 1.26 0 0 1-1.25 1.25c-.695 0-1.25-.57-1.25-1.25 0-.649.49-1.18 1.122-1.244l.128-.006zm-.009-8.17a3 3 0 0 1 3 3c0 1.08-.5 1.76-1.425 2.402-.385.256-.532.426-.56.672L13 13v.25a1 1 0 0 1-1.993.117L11 13.25V13c0-1.035.46-1.72 1.273-2.306l.167-.116c.426-.295.55-.464.55-.748a1 1 0 0 0-1-1 .992.992 0 0 0-.993.882l-.007.118a1 1 0 0 1-2 0c0-1.662 1.338-3 3-3z",
    fill: "#111827",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsQuestionCircle);
export default __webpack_public_path__ + "static/media/icons-question-circle.f392bf8ce26eb339ad872f3b655a5e7e.svg";
export { ForwardRef as ReactComponent };